module.exports = __webpack_public_path__ + "double-merch-mobile.jpg";